module.exports = __webpack_public_path__ + "img/lupin.cf0145dd.svg";